var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 872,
    height: 239,
    viewBox: "0 0 872 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.8159,
    y: 237.832,
    width: 846.182,
    height: 0.990017,
    fill: "#E8F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700.265 84.7484C703.082 76.0127 711.213 70.0917 720.391 70.0917C729.57 70.0917 737.7 76.0123 740.518 84.7476L790.04 238.286H650.75L700.265 84.7484Z",
    fill: "#5C889B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M535.689 35.2724C538.41 26.9787 546.151 21.3715 554.88 21.3715V21.3715C563.609 21.3715 571.35 26.9788 574.071 35.2725L640.868 238.859H468.892L535.689 35.2724Z",
    fill: "#5C889B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.212 75.9605C421.466 68.6349 428.235 63.6359 435.899 63.6359C443.564 63.6359 450.332 68.6351 452.586 75.961L502.724 238.928H369.069L419.212 75.9605Z",
    fill: "#5C889B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9163 14.4407C86.1205 5.76289 94.3916 0 103.642 0C112.892 0 121.163 5.76279 124.368 14.4405L207.286 239H0L82.9163 14.4407Z",
    fill: "#5C889B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.599090c289559cb02996b2fbebad5909.svg";
export { ForwardRef as ReactComponent };